import makeStyles from '@mui/styles/makeStyles';
import { type Theme } from '@mui/material';
import colors from '../../styles/colors';

export const useStyles = makeStyles((theme: Theme) => ({
  container: {
    width: '100%',
    height: '49vw',
    maxHeight: '820px',
    position: 'relative',
    overflow: 'hidden',
    [theme.breakpoints.down(600)]: {
      height: '100%',
    },
    background:
      'linear-gradient(90deg, rgba(36, 48, 54, 0.80) 0%, rgba(130, 130, 130, 0.20) 100%)',
  },
  imageContainer: {
    position: 'absolute',
    left: '0px',
    top: '0px',
    width: '100%',
    zIndex: -1,
  },
  content: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    marginLeft: '11%',
    maxWidth: '1000px',
    width: '60%',
    height: '100%',
    [theme.breakpoints.down(800)]: {
      width: '95%',
      marginLeft: '0px',
      paddingLeft: '20px',
      paddingRight: '20px',
    },
    [theme.breakpoints.down(600)]: {
      width: '100%',
    },
  },
  networkNameContainer: {
    display: 'flex',
    alignItems: 'center',
    gap: '12px',
    marginBottom: '25px',
    [theme.breakpoints.down(600)]: {
      gap: '8px',
      marginTop: '56px',
    },
  },
  networkIcon: {
    flexShrink: 0,
    [theme.breakpoints.down(600)]: {
      width: '16px',
      height: '16px',
    },
  },
  networkName: {
    fontFamily: ['Pitch Sans', 'sans-serif'].join(','),
    fontSize: '20px',
    fontWeight: 600,
    lineHeight: '16px',
    whiteSpace: 'pre-wrap',
    color: colors.white,
    textTransform: 'uppercase',
    [theme.breakpoints.down(600)]: {
      fontSize: '12px',
    },
  },
  title: {
    fontFamily: ['Procore Sans', 'sans-serif'].join(','),
    fontSize: '88px',
    fontWeight: 700,
    lineHeight: '92px',
    whiteSpace: 'pre-wrap',
    color: colors.white,
    marginBottom: '72px',
    [theme.breakpoints.down(1070)]: {
      fontSize: '44px',
      fontWeight: 700,
      lineHeight: '48px',
    },
    [theme.breakpoints.down(680)]: {
      fontSize: '28px',
      fontWeight: 700,
      lineHeight: '36px',
      marginBottom: '56px',
    },
  },
  subTitle: {
    fontSize: '24px',
    fontWeight: 700,
    lineHeight: '32px',
    color: colors.white,
    marginBottom: '12px',
    [theme.breakpoints.down(600)]: {
      fontSize: '20px',
      fontWeight: 700,
      lineHeight: '28px',
    },
  },
  searchBarRow: {
    minWidth: '460px',
    maxWidth: '761px',
    [theme.breakpoints.down(600)]: {
      minWidth: '100%',
      maxWidth: '100%',
      marginBottom: '56px',
    },
  },
}));

export const useHeroProjectOpenToBidStyles = makeStyles((theme: Theme) => ({
  container: {
    width: '100%',
    height: '49vw',
    maxHeight: '820px',
    position: 'relative',
    overflow: 'hidden',

    [theme.breakpoints.down(1185)]: {
      height: '55vw',
    },
    [theme.breakpoints.down(1074)]: {
      height: '64vw',
    },

    [theme.breakpoints.down(1070)]: {
      height: '55vw',
    },

    [theme.breakpoints.down('md')]: {
      height: '59vw',
    },
    [theme.breakpoints.down(850)]: {
      height: '64vw',
    },
    [theme.breakpoints.down(800)]: {
      height: '69vw',
    },

    [theme.breakpoints.down(750)]: {
      height: '75vw',
    },
    [theme.breakpoints.down(700)]: {
      height: '79vw',
    },
    [theme.breakpoints.down(650)]: {
      height: '89vw',
    },
    [theme.breakpoints.down(600)]: {
      height: '100%',
    },

    background:
      'linear-gradient(90deg, rgba(36, 48, 54, 0.80) 0%, rgba(130, 130, 130, 0.20) 100%)',
  },
  imageContainer: {
    position: 'absolute',
    left: '0px',
    top: '0px',
    width: '100%',
    zIndex: -1,
    height: '100%',
  },
  content: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    marginLeft: '11%',
    maxWidth: '1000px',
    width: '60%',
    height: '100%',
    [theme.breakpoints.down('md')]: {
      width: '75%',
    },
    [theme.breakpoints.down(800)]: {
      width: '95%',
      marginLeft: '0px',
      paddingLeft: '20px',
      paddingRight: '20px',
    },
    [theme.breakpoints.down(600)]: {
      width: '100%',
    },
  },
  networkNameContainer: {
    display: 'flex',
    alignItems: 'center',
    gap: '12px',
    marginBottom: '25px',
    [theme.breakpoints.down(600)]: {
      gap: '8px',
      marginTop: '44px',
      marginBottom: '28px',
    },
  },
  networkIcon: {
    flexShrink: 0,
    [theme.breakpoints.down(600)]: {
      width: '16px',
      height: '16px',
    },
  },
  networkName: {
    fontFamily: ['Pitch Sans', 'sans-serif'].join(','),
    fontSize: '20px',
    fontWeight: 600,
    lineHeight: '16px',
    whiteSpace: 'pre-wrap',
    color: colors.white,
    textTransform: 'uppercase',
    [theme.breakpoints.down(600)]: {
      fontSize: '15px',
    },
  },
  title: {
    fontFamily: ['Procore Sans', 'sans-serif'].join(','),
    fontSize: '88px',
    fontWeight: 700,
    lineHeight: '92px',
    whiteSpace: 'pre',
    color: colors.white,
    marginBottom: '42px',
    [theme.breakpoints.down(1185)]: {
      fontSize: '44px',
      fontWeight: 700,
      lineHeight: '48px',
    },
    [theme.breakpoints.down(900)]: {
      marginBottom: '36px',
    },
    [theme.breakpoints.down(680)]: {
      fontSize: '32px',
      fontWeight: 700,
      lineHeight: '36px',
      marginBottom: '28px',
    },
    [theme.breakpoints.down(380)]: {
      whiteSpace: 'pre-wrap',
    },
  },
  subTitle: {
    fontSize: '24px',
    fontWeight: 700,
    lineHeight: '32px',
    color: colors.white,
    marginBottom: '12px',
    [theme.breakpoints.down(600)]: {
      fontSize: '20px',
      fontWeight: 700,
      lineHeight: '28px',
    },
  },
  searchBarRow: {
    minWidth: '460px',
    maxWidth: '761px',
    [theme.breakpoints.down(600)]: {
      minWidth: '100%',
      maxWidth: '100%',
      marginBottom: '56px',
    },
  },
}));
